import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDeliveryNoteTemplatesStore } from "../../stores/delivery_note_templates";
import { useDeliveryNotesStore } from "../../stores/delivery_notes";
import { useWorkOrdersStore } from "../../stores/work_orders";
import { useShallow } from "zustand/react/shallow";
import { useTranslation } from "react-i18next";
import MobileActionBarContent from "../../components/mobile-action-bar/MobileActionBarContent";

function Home() {
  const { t } = useTranslation();
  const { templatesByIds, templatesAllIds, fetchSomeTemplates } =
    useDeliveryNoteTemplatesStore(
      useShallow((state) => ({
        templatesByIds: state.byIds,
        templatesAllIds: state.allIds,
        fetchSomeTemplates: state.fetchSome,
      })),
    );

  const { totalDraft, fetchDraftTotal } = useDeliveryNotesStore(
    useShallow((state) => ({
      totalDraft: state.totalDraft,
      fetchDraftTotal: state.fetchDraftTotal,
    })),
  );

  const { totalOpenWorkOrders, fetchOpenWorkOrderTotal } = useWorkOrdersStore(
    useShallow((state) => ({
      totalOpenWorkOrders: state.totalOpen,
      fetchOpenWorkOrderTotal: state.fetchOpenTotal,
    })),
  );

  useEffect(() => {
    fetchSomeTemplates({ q: "", limit: 20, offset: 0 });
    fetchDraftTotal();
    fetchOpenWorkOrderTotal();
  }, [fetchDraftTotal, fetchOpenWorkOrderTotal, fetchSomeTemplates]);

  const renderQueues = () => (
    <>
      <Link to="/work_orders?filter=open" className="btn btn-default flex-1">
        {t("work_orders.work_orders")}
        {totalOpenWorkOrders > 0 && (
          <span className="badge bg-red ms-2">{totalOpenWorkOrders}</span>
        )}
      </Link>
      <Link to="/delivery_notes?filter=draft" className="btn btn-default flex-1">
        {t("delivery_notes.delivery_notes")}
        {totalDraft > 0 && <span className="badge bg-red ms-2">{totalDraft}</span>}
      </Link>
    </>
  );

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="my-auto my-md-0 px-3 px-md-0">
        {templatesAllIds.map((sid) => (
          <Link
            key={sid}
            to={`/delivery_notes/add?templateId=${sid}`}
            className="btn btn-lg btn-red w-100 mb-2 min-h-45px"
          >
            {t("delivery_notes.delivery_note")} {templatesByIds[sid].name}
          </Link>
        ))}
        <div className="d-none d-md-flex gap-2 mt-2">{renderQueues()}</div>
      </div>
      <MobileActionBarContent>
        <div className="d-flex gap-2 w-100">{renderQueues()}</div>
      </MobileActionBarContent>
    </div>
  );
}

export default Home;
